var React = require('react');
var { useSelector, useDispatch } = require('react-redux');
var { useTranslation } = require('react-i18next');
var meteorologicalStationsActions = require('@actions/meteorologicalStationsActions');

const MeteorologicalData = ({ field, onStationAdd }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const availableStations = useSelector(
    (state) => state.meteorological_stations_data?.stations,
  );

  const [selectedStationId, setSelectedStationId] = React.useState('');
  const meteorologicalSources = field?.geo_data?.meteorological_sources || [];
  const currentStationIds = field?.geo_data?.meteorological_stations || [];

  React.useEffect(() => {
    dispatch(meteorologicalStationsActions.load_meteorological_stations());
  }, [dispatch]);

  // Filter out stations that are already added and sort alphabetically
  const availableToAdd = (availableStations || [])
    .filter((station) => !currentStationIds.includes(String(station.id)))
    .sort((a, b) => a.name.localeCompare(b.name));

  // Get names of stations that are in currentStationIds but not in meteorologicalSources
  // (i.e., newly added stations that haven't been saved yet)
  const newlyAddedStationNames = React.useMemo(() => {
    if (!availableStations) return [];
    return currentStationIds
      .map((stationId) => {
        const station = availableStations.find(
          (s) => String(s.id) === String(stationId),
        );
        return station?.name;
      })
      .filter((name) => name && !meteorologicalSources.includes(name));
  }, [currentStationIds, availableStations, meteorologicalSources]);

  // Combine existing sources with newly added station names
  const allDisplayedSources = [
    ...meteorologicalSources,
    ...newlyAddedStationNames,
  ];

  const handleAddStation = () => {
    if (selectedStationId && onStationAdd) {
      onStationAdd(selectedStationId);
      setSelectedStationId('');
    }
  };

  return (
    <div className='form-row justify-content-start'>
      <div className='col-12'>
        <div className='form-group ml-2 mr-2 mt-3'>
          <label
            className='font-weight-bold text-size-20'
            htmlFor='meteorologicalData'
          >
            {t('meteorological_data')}
          </label>
          <div className='mt-2'>
            {allDisplayedSources.length === 0 ? (
              <div className='text-grey71 text-size-14'>
                {t('no_custom_station_added')}
              </div>
            ) : (
              allDisplayedSources.map((source) => (
                <div
                  key={source}
                  className='text-size-14 font-weight-normal text-grey45'
                >
                  {source}
                </div>
              ))
            )}
          </div>

          {onStationAdd && availableToAdd.length > 0 && (
            <div className='mt-3 d-flex align-items-center'>
              <select
                className='form-control custom-select'
                style={{ maxWidth: '300px', background: 'none' }}
                value={selectedStationId}
                onChange={(e) => setSelectedStationId(e.target.value)}
              >
                <option value=''>{t('select_station')}</option>
                {availableToAdd.map((station) => (
                  <option key={station.id} value={station.id}>
                    {station.name}
                  </option>
                ))}
              </select>
              <button
                type='button'
                className='btn ml-2 text-white'
                style={{
                  backgroundColor: 'var(--color-primary-idel)',
                  borderRadius: '3px',
                  padding: '8px 16px',
                }}
                onClick={handleAddStation}
                disabled={!selectedStationId}
              >
                {t('add')}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

module.exports = MeteorologicalData;
